import { Clipboard } from '@angular/cdk/clipboard';
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
  UntypedFormControl,
  AbstractControl,
} from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { DateTime } from 'luxon';
import moment, { Moment } from 'moment';

// ANIMATIONS

// COMPONENTS

// DIRECTIVES

// CONFIGS

// INTERFACES

// SERVICES

// UTILS

//OTHERS
import { NgxPermissionsService } from 'ngx-permissions';
import {
  BehaviorSubject,
  Observable,
  Subject,
  forkJoin,
  EMPTY,
  combineLatest,
} from 'rxjs';
import {
  tap,
  takeUntil,
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  delay,
  finalize,
} from 'rxjs/operators';

import { ClientPurchaseOrderCreatedFrom } from '@app/core/_constant/b2b-clients.constants';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

import { IChannelHubspotDeal } from '../../../channel/interfaces/channel.interface';
import {
  ICompany,
  IBusinessAccountContact,
  IClientShipping,
  EClientCreditMemoStatus,
  IClientCreditMemo,
  IClientPurchaseOrderDiscount,
  ICreditMemoPaymentLog,
  IClientCreditMemoEntry,
} from '../../../client/interfaces';
import { ICustomFieldValue } from '../../../custom-field/interfaces';
import {
  EOrderFrequency,
  EOrderDeliveryType,
  EOrderStatus,
  ESalesOrderStatus,
} from '../../../order/interfaces';
import {
  IPrice,
  IPricingLevel,
} from '../../../pricing/interfaces/pricing.interface';
import { IWarehouseGroup } from '../../../shared/interfaces/location-warehouse.interface';
import { IChannel } from '../../../shared/interfaces/mtchannel.interface';
import { EInvoicePermission } from '../../../shared/interfaces/permissions.interface';
import {
  ClientCompanyApiService,
  ClientCreditMemoApiService,
  ClientPurchaseOrderApiService,
  ClientShippingApiService,
  PricingApiService,
  PricingLevelApiService,
  LocationApiService,
  ClientApiService,
  InvoiceApiService,
  ChannelApiService,
  RfqUtilService,
  SalesPurgatoryApiService,
  LocationWarehouseGroupApiService,
  RfqApiService,
  OrderClientPurchaseService,
} from '../../../shared/services';
import { parseUTCStringToDateISO } from '../../../shared/util';
import { ISalesPurgatorySettings } from '../../../system-setting/interfaces';
import { InvoiceConfig } from '../../config/invoice.config';
import {
  EInvoiceApprovalStatus,
  EInvoiceStatus,
  IInvoiceLineItem,
  IInvoiceType,
  ELineItemRowType,
} from '../../interfaces/invoice.interface';

import { DialogConfig, SnackBarConfig } from './../../../shared/configs';
import { IKeyValue } from './../../../shared/interfaces/common.interface';
import { UiConfirmationDialogComponent } from './../../../ui/components/ui-confirmation-dialog/ui-confirmation-dialog.component';

interface IResponse {
  data :IInvoiceType[];
  links :any;
  meta :any;
}

@Component({
  selector: 'lum-invoice-client',
  templateUrl: './invoice-client.component.html',
  styleUrls: ['./invoice-client.component.scss'],
})
export class InvoiceClientComponent implements OnInit, OnDestroy {
  @Input()
  packageManagementEnabled :boolean = false;

  @Input()
  newKitsStructureEnabled :boolean = false;

  @Input()
  lotTrackingEnabled :boolean = false;

  @Input()
  customFieldsEnabled :boolean = false;

  @Input()
  permissions :any = {};

  companies :ICompany[] = [];
  companies$ :Observable<ICompany[]>;
  contacts$ :Observable<IBusinessAccountContact[]>;
  contacts :IBusinessAccountContact[] = [];
  channelHubspotDeal$ :Observable<IChannelHubspotDeal>;
  creditMemo$ :Observable<IClientCreditMemo[]>;
  creditMemos :IClientCreditMemo[] = [];
  creditMemoPaymentLogs :ICreditMemoPaymentLog[] = [];
  countries$ :Observable<IKeyValue[]>;
  currentCompany :ICompany | null;
  currentCompany$ :Observable<ICompany | null>;
  discountEntries :IClientPurchaseOrderDiscount[] = [];
  editContact :boolean = false;
  editShipping :boolean = false;
  templateId :string = '';
  form :UntypedFormGroup;
  loadingCompanies$ :Observable<boolean>;
  loadingWarehouseGroups$ :Observable<boolean>;
  loadingWarehouseGroupsOnSelect$ :Observable<boolean>;
  pricingByRfq$ :Observable<{
    [key :string] :IPrice;
  }>;
  pricingByRfq :{
    [key :string] :IPrice;
  } = {};
  pricingLevels$ :Observable<IPricingLevel[]>;
  shippingAddresses :IClientShipping[] = [];
  shippingAddresses$ :Observable<IClientShipping[]>;
  warehouseGroups :IWarehouseGroup[] = [];
  warehouseGroups$ :Observable<IWarehouseGroup[]>;
  currentInvoice$ :Observable<any>; // TODO: Create type
  currentInvoice :any = null;
  initialValues :any = null; // TODO: Create type
  submittingForm$ :Observable<boolean>;
  loading$ :Observable<boolean>;
  invoiceStatus = EInvoiceStatus;
  uploadingSku$ :Observable<boolean>;
  salesPurgatorySettings :any = {}; // TODO: Create Type
  salesPurgatorySettings$ :Observable<ISalesPurgatorySettings>;
  invoiceTypes$ :Observable<IResponse>;
  loadContact :boolean = true;
  initContactForm :boolean = true;
  defaultWarehouseGroupFromInventorySettings :IWarehouseGroup = null;
  currentWarehouseGroup :IWarehouseGroup = null;
  generatingB2BLink :boolean = false;
  defaultDueDays :number = 30;
  redirectUrl :string;
  shouldIncludeAllWarehouseGroups :boolean = false;

  searchClientEventValue :string = '';
  paginateClientsPage :number = 1;

  private onDestroy$ = new Subject();

  private updatingFormFields = new BehaviorSubject<boolean>(false);
  updatingFormFields$ :Observable<boolean> = this.updatingFormFields.asObservable();

  //PERMISSIONS
  private canSaveDraftSubject = new BehaviorSubject<boolean>(false);
  canSaveDraft$ = this.canSaveDraftSubject.asObservable();
  private canSaveCompletedSubject = new BehaviorSubject<boolean>(false);
  canSaveCompleted$ = this.canSaveCompletedSubject.asObservable();
  private canSaveActiveSubject = new BehaviorSubject<boolean>(false);
  canSaveActive$ = this.canSaveActiveSubject.asObservable();

  constructor(
    private cd :ChangeDetectorRef,
    private channelApiService :ChannelApiService,
    private clientApiService :ClientApiService,
    private clientCompanyApiService :ClientCompanyApiService,
    private clientCreditMemoApiService :ClientCreditMemoApiService,
    private clientPurchaseOrderApiService :ClientPurchaseOrderApiService,
    private clientShippingApiService :ClientShippingApiService,
    private dialog :MatDialog,
    private fb :UntypedFormBuilder,
    private ftService :FeatureToggleService,
    private invoiceApiService :InvoiceApiService,
    private locationApiService :LocationApiService,
    private pricingApiService :PricingApiService,
    private pricingLevelApiService :PricingLevelApiService,
    private route :ActivatedRoute,
    private router :Router,
    private salesPurgatoryApiService :SalesPurgatoryApiService,
    private snackBar :MatSnackBar,
    private rfqUtilService :RfqUtilService,
    private warehouseGroupService :LocationWarehouseGroupApiService,
    private rfqApiService :RfqApiService,
    private permissionService :NgxPermissionsService,
    private orderClientPurchaseService :OrderClientPurchaseService,
    private clipboard :Clipboard,
    private settingsSvc :SettingsService,
  ) {}

  ngOnInit() :void {
    this.initRedirectUrl();
    this.initActions();
    this.getRouterParams().subscribe();
    this.getRouterQueryParams().subscribe();
    this.getFromService();
    this.initFormValues();
    this.initForm();
    this.loadDefaultSalesChannel();
    this.salesPurgatoryApiService.getSettings({});
    this.loadWarehouseGroups();
    this.loadDefaultWarehouseGroup();
    this.setPermissions();

    // FORM VALUE EVENT LISTENERS
    this.listToClientFormChange();
    this.listenToLineItemsChange();
    this.listenToShippingAmountChange();
    this.listenToTaxAmountChange();
    this.listenToShippingAddress();
    this.listenToPricingLevelChange();
    this.listenToDefaultPosChannelChange();

    // OBSERVABLES SUBSCRIPTIONS
    this.getCurrentInvoice().subscribe();
    this.getShippingAddresses().subscribe();
    this.getCompanies().subscribe();
    this.getContacts().subscribe();
    this.getCreditMemos().subscribe();
    this.getPricingByRfq().subscribe();
    this.getCurrentCompany().subscribe();
    this.getInvoiceTypes().subscribe();
    this.getChannelHubspotDeal().subscribe();
    this.getSalesPurgatorySettings().subscribe();
  }

  loadDefaultSalesChannel() :void {
    const { sales_channel_id } = this.initialValues;

    if (sales_channel_id) {
      this.getPosSalesChannelById(sales_channel_id);
    } else {
      this.getInvoiceSettings();
    }
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSelectCompany(data :{ currentCompany :ICompany }) :void {
    const { currentCompany } = data;
    this.clientCompanyApiService.setCurrentCompany(currentCompany || null);
    if (currentCompany?.payment_term) {
      this.form.patchValue({
        payment_term_title: currentCompany?.payment_term,
      });
    }

    this.onSetDefaultCompanyDueDate(currentCompany);
    this.updateLineItemPrices();
  }

  onSelectContact(contactId :number) :void {
    const contact = this.contacts.find((contact) => contact.id === contactId);
    const currentShipping = this.shippingAddresses.find(
      (shipping) => shipping.id === this.form.get('shipping_address_id').value,
    );
    const isAvailableShippingAddressName = !!(
      currentShipping?.firstName && currentShipping?.lastName
    );
    const shippingAddressName =
      currentShipping.firstName + currentShipping.lastName;

    if (contact) {
      this.form.patchValue({
        shipping_email: contact.userAccount.email || '',
        shipping_phone: contact.userAccount.phoneOne || '',
        shipping_name: isAvailableShippingAddressName
          ? shippingAddressName
          : contact.userAccount.fullName || '',
        shipping_company: contact.businessAccount.businessName || '',
      });
    }
  }

  onSearchClientEvent(client :string) :void {
    this.searchClientEventValue = client;
    this.paginateClientsPage = 1;
    this.clientCompanyApiService.get({
      business_name: client,
      relations: 'clientType.warehouseGroup',
    });
  }

  onClearClientEvent(status :boolean) :void {
    if (status) {
      this.resetForm();
    }
  }

  onSaveInvoice(status :EInvoiceStatus) :void {
    if (this.form.invalid) {
      this.snackBar.open('Please fill in all required fields.', 'Fail', {
        duration: SnackBarConfig.DEFAULT.duration,
      });

      return;
    }
    if (this.hasInvalidCreditMemoEntryAmount) {
      this.snackBar.open(
        'The amount should not exceed the credit memo balance amount.',
        'Fail',
        {
          duration: SnackBarConfig.DEFAULT.duration,
        },
      );

      return;
    }
    if (this.isInValidCreditMemoEntryId || this.hasNegativeCreditMemoEntryAmount) {
      this.snackBar.open('Invalid credit memo entry.', 'Fail', {
        duration: SnackBarConfig.DEFAULT.duration,
      });

      return;
    }
    if (!this.isValidPaymentNetAmount) {
      this.snackBar.open(
        'Total Credit Memo Entry Amount is greater than Net Amount.',
        'Fail',
        {
          duration: SnackBarConfig.DEFAULT.duration,
        },
      );

      return;
    }
    if (
      this.hasInvalidPurgatorySettingsInput &&
      this.pushClientInvoiceToShipstation
    ) {
      this.snackBar.open('Please check and fill the required fields.', 'Fail', {
        duration: SnackBarConfig.DEFAULT.duration,
      });

      return;
    }

    // Make line items required
    if (!this.lineItemsFormArray?.value?.filter((item :any) => item.sku)?.length) {
      this.snackBar.open('Please add at least one line item.', 'Fail', {
        duration: SnackBarConfig.DEFAULT.duration,
      });

      return;
    }

    // TODO: Only require warehouseGroup if invoiceType.auto_push_updates_to_sales_order == true
    // if (!this.warehouseGroupId) {
    //   this.snackBar.open(
    //     'Please select a warehouse group in Advance Settings.',
    //     'Fail',
    //     {
    //       duration: SnackBarConfig.DEFAULT.duration,
    //     },
    //   );
    //   return;
    // }

    const value = this.form.value;
    const emptyQtySku :string[] = value.line_items
      .filter((item :IInvoiceLineItem) => item.quantity === null)
      .map((item :IInvoiceLineItem) => item.sku);
    if (emptyQtySku.length > 0) {
      this.snackBar.open(
        `item SKU(s): ${emptyQtySku.join(', ')} has empty quantity.`,
        'Fail',
        {
          duration: SnackBarConfig.DEFAULT.duration,
        },
      );

      return;
    }
    const line_items :any[] = value.line_items
      .filter(
        (item :any) => item.sku || item.row_type === ELineItemRowType.SUB_TOTAL,
      )
      .map((item :any, index :number) => {
        const {
          unit_of_measures,
          stock,
          location_stock,
          original_unit_price,
          oss_limit_notify,
          type,
          selected,
          product,
          unit_class_id,
          category,
          subcategory,
          ...filteredItem
        } = item;

        return {
          ...filteredItem,
          order: index,
        };
      });
    const creditMemoEntriesPayload :{ creditMemoId :number; amount :number }[] =
      value.creditMemoEntries
        .filter(
          (creditMemoEntry :IClientCreditMemoEntry) =>
            creditMemoEntry?.applyCreditMemoEntry &&
            creditMemoEntry?.creditMemo?.id &&
            creditMemoEntry?.amount !== 0,
        )
        .map((creditMemoEntry :IClientCreditMemoEntry) => {
          return {
            creditMemoId: creditMemoEntry.creditMemo?.id,
            amount: creditMemoEntry.amount,
          };
        });
    const _toISODate = (date :string | Date | Moment) :string => {
      if (moment.isMoment(date)) {
        date.set('hour', 0);
        date.set('minute', 0);
        date.set('second', 0);

        return date.toISOString();
      } else {
        const dateObj = new Date(date);
        dateObj.setHours(0, 0, 0, 0);

        return dateObj.toISOString();
      }
    };

    // Set order date to current time for accurate display when viewing in a different timezone
    // This is to ensure that the order date reflects the current time when the invoice is created
    const now = moment();
    const orderDate = moment(value.order_date);
    orderDate.hour(now.hour())
      .minute(now.minute())
      .second(now.second())
      .millisecond(now.millisecond());

    const payload = {
      ...value,
      line_items,
      ship_by_date: value.ship_by_date ? _toISODate(value.ship_by_date) : null,
      order_date: orderDate.toISOString(),
      due_date: value.due_date ? _toISODate(value.due_date) : null,
      order_status: status,
      client_id: this.currentCompany?.id,
      total_units: this.totalUnits,
      discount_amount: this.discountAmount,
      discount_percent: this.discountPercent,
      discountEntries: this.discountEntries,
      creditMemoEntries: creditMemoEntriesPayload,
    };
    if (this.isEditInvoice && this.creditMemoPaymentLogs?.length > 0) {
      delete payload.creditMemoEntries;
    }

    if (!this.currentInvoice || this.templateId) {
      this.clientPurchaseOrderApiService
        .create(payload)
        .pipe(
          tap(() => {
            this.snackBar.open('Invoice successfully created.', 'Success', {
              duration: SnackBarConfig.DEFAULT.duration,
            });
            this.resetForm();
            this.router.navigate([this.redirectUrl]);
          }),
          takeUntil(this.onDestroy$),
          catchError((error :any[]) :any => {
            this.snackBar.open(
              Object.values(error)[0] ?? 'Please fill all the required fields.',
              'Fail',
              {
                duration: SnackBarConfig.DEFAULT.duration,
              },
            );
          }),
        )
        .subscribe();
    } else {
      if (this.currentInvoice?.sales_order?.client_invoices_count > 1) {
        this.dialog
          .open(UiConfirmationDialogComponent, {
            data: {
              title: 'Are you sure you want to update this invoice?',
              message:
                'Multiple invoices are associated with the sales order linked to this invoice. Changes will not be reflected on the sales order.',
            },
            width: DialogConfig.sizes.small,
          })
          .afterClosed()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((confirm :boolean) => {
            if (confirm) {
              payload.skipSalesOrderUpdate = true;
              this.updateRfq(payload);
            }
          });
      } else if (
        this.lineItemsFormArray.dirty &&
        this.currentInvoice?.sales_order?.orderStatus !== ESalesOrderStatus.SHIPPED
      ) {
        this.dialog
          .open(UiConfirmationDialogComponent, {
            data: {
              title: 'Are you sure you want to update this invoice?',
              message:
                'There is already an existing sales order, by editing this invoice we\'ll delete the existing sales order and create a new one',
            },
            width: DialogConfig.sizes.small,
          })
          .afterClosed()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((confirm :boolean) => {
            if (confirm) {
              this.updateRfq(payload);
            }
          });
      } else {
        this.updateRfq(payload);
      }
    }
  }

  onApproveInvoice() :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Confirm Approval?',
          message: 'This will approve the invoice and mark it as ACTIVE.',
        },
        width: DialogConfig.sizes.small,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((confirm :boolean) => {
        if (confirm) {
          this.clientPurchaseOrderApiService
            .approve(this.currentInvoice.id)
            .pipe(
              tap(() => {
                this.snackBar.open('Invoice Approved', 'Success', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });
                this.resetForm();
                this.router.navigate([this.redirectUrl]);
              }),
              takeUntil(this.onDestroy$),
              catchError((error :any[]) :any => {
                this.snackBar.open(Object.values(error)[0], 'Fail', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });
              }),
            )
            .subscribe();
        }
      });
  }

  onRejectInvoice() :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Confirm Rejection?',
          message: 'This will reject this invoice and mark it as DRAFT again.',
        },
        width: DialogConfig.sizes.small,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((confirm :boolean) => {
        if (confirm) {
          this.clientPurchaseOrderApiService
            .reject(this.currentInvoice.id)
            .pipe(
              tap(() => {
                this.snackBar.open('Invoice Rejected.', 'Success', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });
                this.resetForm();
                this.router.navigate([this.redirectUrl]);
              }),
              takeUntil(this.onDestroy$),
              catchError((error :any[]) :any => {
                this.snackBar.open(Object.values(error)[0], 'Fail', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });
              }),
            )
            .subscribe();
        }
      });
  }

  onRemoveLineItem(index :number) :void {
    const subTotalIndex = index + 1;

    if (
      this.lineItemsFormArray.controls[subTotalIndex]?.value?.row_type ===
      ELineItemRowType.SUB_TOTAL
    ) {
      this.lineItemsFormArray.removeAt(subTotalIndex);
    }

    this.lineItemsFormArray.removeAt(index);
    setTimeout(() => {
      this.onRecalculateSubtotals();
      this.cd.detectChanges();
    }, 500);
  }

  onRemoveCreditMemoEntry(index :number) :void {
    this.invoiceCreditMemoFormArray.removeAt(index);
  }

  onAddLineItem(data :{
    item :any;
    index ?:number;
    insertPosition ?:'top' | 'bottom';
  }) :void {
    const { item, index, insertPosition } = data;
    const { quantity, default_selling_unit_id } = item;

    const ordered_uom = item.unit_of_measures.find(
      (uom :any) => uom.id === default_selling_unit_id,
    );

    const itemGroup = this.rfqUtilService.getItemFormGroup(item);

    if (index !== undefined) {
      this.lineItemsFormArray.setControl(index, itemGroup);
    } else {
      // Find the index where the empty/default values end
      let insertIndex = this.lineItemsFormArray.length;
      let emptyCount = 0;
      for (let i = this.lineItemsFormArray.length - 1; i >= 0; i--) {
        const control = this.lineItemsFormArray.at(i);
        const value = control.value;
        if (value.product_name !== '') {
          break;
        }
        emptyCount++;
      }
      if (emptyCount > 0) {
        insertIndex = this.lineItemsFormArray.length - emptyCount;
      }
      this.lineItemsFormArray.insert(
        insertPosition === 'top' ? 0 : insertIndex,
        itemGroup,
      );
    }

    this.pricingApiService.getByRfq({
      rfqId: item.id.toString(),
      quantity,
      uomId: ordered_uom?.id?.toString(),
      businessAccountId: this.currentCompany?.id?.toString() || '',
      priceLevelId: this.pricingLevelIdControl?.value || null,
    });
  }

  onAddRowItems(count :number) :void {
    for (let i = 0; i < count; i++) {
      this.lineItemsFormArray.push(this.rfqUtilService.emptyItemRow());
    }
  }

  onAddRowItemSubTotal(index :number | null) :void {
    const rows = this.lineItemsFormArray.controls.filter(
      (control :AbstractControl) =>
        control.value.row_type === ELineItemRowType.SUB_TOTAL,
    );

    if (index === null) {
      // remove all subtotal rows
      rows.forEach((row :AbstractControl) => {
        this.lineItemsFormArray.removeAt(
          this.lineItemsFormArray.controls.indexOf(row),
        );
      });

      return;
    } else {
      const subTotalIndex = index + 1;

      // check if index is already a subtotal row
      if (
        this.lineItemsFormArray.controls[subTotalIndex]?.value?.row_type ===
        ELineItemRowType.SUB_TOTAL
      ) {
        // Remove row at index subTotalIndex
        this.lineItemsFormArray.removeAt(subTotalIndex);
        this.onRecalculateSubtotals();

        return;
      }

      let inlineSubtotal = 0;
      let inlineTotalUnits = 0;

      // Find the last index of row type subtotal
      const previousSubtotalIndex = this.lineItemsFormArray.value.reduce(
        (lastIndex :number, item :any, index :number) => {
          return item.row_type === ELineItemRowType.SUB_TOTAL ? index : lastIndex;
        },
        -1,
      );

      const startIndex =
        previousSubtotalIndex < index ? previousSubtotalIndex : index;

      // Start the calculation from the startIndex to index
      this.lineItemsFormArray.controls.forEach((control, i) => {
        if (i >= startIndex && i <= index && !control.value.row_type) {
          inlineSubtotal += control.get('net_total_amount')?.value;
          inlineTotalUnits += parseFloat(control.get('quantity')?.value || 0);
        }
      });

      this.lineItemsFormArray.insert(
        subTotalIndex,
        this.rfqUtilService.emptyItemRow(),
      );

      // Update net_total_amoung and quantity row with index value subTotal index
      this.lineItemsFormArray.controls[subTotalIndex].patchValue({
        net_total_amount: inlineSubtotal,
        quantity: inlineTotalUnits,
        row_type: ELineItemRowType.SUB_TOTAL,
      });

      this.onRecalculateSubtotals();
    }
  }

  onRecalculateSubtotals() :void {
    let runningSubtotal = 0;
    let runningTotalUnits = 0;

    this.lineItemsFormArray.controls.forEach((control, i) => {
      if (control.value.row_type === ELineItemRowType.SUB_TOTAL) {
        // Update the subtotal row with the current running totals
        control.patchValue({
          net_total_amount: runningSubtotal,
          quantity: runningTotalUnits,
        });

        // Reset the running totals after each subtotal row
        runningSubtotal = 0;
        runningTotalUnits = 0;
      } else {
        // Accumulate totals for regular rows
        runningSubtotal += parseFloat(control.get('net_total_amount')?.value || 0);
        runningTotalUnits += parseFloat(control.get('quantity')?.value || 0);
      }
    });
  }

  onAddInvoiceCreditMemoEntry(invoiceCreditMemoEntry :UntypedFormGroup) :void {
    this.invoiceCreditMemoFormArray.push(invoiceCreditMemoEntry);
  }

  onSelectRfq(data :{ item :any; tempId :number }) :void {
    const { item, tempId } = data;
    const itemGroup :UntypedFormGroup = this.rfqUtilService.getItemFormGroup(item);
    const index = this.lineItemsFormArray.controls.findIndex(
      (control :AbstractControl) => control.value.item_id === tempId,
    );

    this.lineItemsFormArray.setControl(index, itemGroup);
    this.getRfqById(itemGroup.value);
  }

  onSelectCreditMemo(data :{ creditMemo :IClientCreditMemo; index :number }) :void {
    const { creditMemo, index } = data;
    this.invoiceCreditMemoFormArray.setControl(
      index,
      this.fb.group({
        creditMemo: creditMemo,
        amount: creditMemo.balanceAmount,
        applyCreditMemoEntry: true,
      }),
    );
  }

  onGenerateB2BLink() :void {
    this.generatingB2BLink = true;
    this.snackBar.open('Generating B2B Portal link...', 'Info');
    this.orderClientPurchaseService
      .createShareableLink(this.currentInvoice.id)
      .pipe(
        finalize(() => {
          this.generatingB2BLink = false;
          this.cd.detectChanges();
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe({
        next: (token :any) => {
          this.currentInvoice = {
            ...this.currentInvoice,
            shareable_token: token,
          };
          this.snackBar.dismiss();
          this.snackBar.open('B2B Portal link generated.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
        error: () => {
          this.snackBar.dismiss();
          this.snackBar.open('Failed to generate B2B Portal link.', 'Fail');
        },
      });
  }
  copyTokenToClipboard() :void {
    let link = '';
    const storageKey = `environment_${location.origin}`;
    const clientConfig = JSON.parse(
      localStorage.getItem(storageKey || '{}'),
    )?.clientConfig;

    if (clientConfig?.b2bPortal) {
      if (clientConfig?.b2bPortal) {
        link = `${clientConfig.b2bPortal}/cart?token=${this.currentInvoice.shareable_token}`;

        this.clipboard.copy(link);
        this.snackBar.open('Link copied to clipboard.', 'Success', {
          duration: SnackBarConfig.DEFAULT.duration,
        });
      } else {
        this.snackBar.open('Failed to copy link to clipboard.', 'Fail');
      }
    } else {
      this.snackBar.open('Failed to copy link to clipboard.', 'Fail');
    }
  }

  onPaginateClients() :void {
    this.paginateClientsPage += 1;
    this.clientCompanyApiService.get(
      {
        business_name: this.searchClientEventValue,
        page: this.paginateClientsPage.toString(),
      },
      false,
    );
  }

  private initRedirectUrl() :void {
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo');
    this.redirectUrl = redirectTo || '/sales/view/invoices';
  }

  private initActions() :void {
    this.clientPurchaseOrderApiService.setCurrentPurchaseOrder(null);
    this.clientCompanyApiService.setCurrentCompany(null);
    this.clientCompanyApiService.get({
      relations: 'clientType.warehouseGroup',
    });
    this.clientCompanyApiService.setContacts([]);
    this.pricingLevelApiService.get();
    this.locationApiService.getCountries();
    this.invoiceApiService.getInvoiceTypes({
      per_page: '100',
      page: '1',
    });
  }

  private getRouterParams() :Observable<Params> {
    return this.route.params.pipe(
      tap((params :Params) => {
        const id = params['id'];
        if (id) {
          this.loadContact = true;
          this.clientPurchaseOrderApiService.getById(id);
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getRouterQueryParams() :Observable<Params> {
    return this.route.queryParams.pipe(
      tap((queryParams :Params) => {
        const id = queryParams['templateId'];
        const clientId = queryParams['defaultClientId'];
        const hubSpotDealId = queryParams['hubSpotDealId'];
        if (id) {
          this.loadContact = true;
          this.templateId = id;
          this.clientPurchaseOrderApiService.getById(id);
        }
        if (clientId) {
          this.loadContact = true;
          this.clientCompanyApiService.getById(Number(clientId));
        }

        if (hubSpotDealId) {
          this.channelApiService.getHubSpotDeal(hubSpotDealId);
        }
      }),

      takeUntil(this.onDestroy$),
    );
  }

  private getFromService() :void {
    this.companies$ = this.clientCompanyApiService.companies$;
    this.currentCompany$ = this.clientCompanyApiService.currentCompany$;
    this.loadingCompanies$ = this.clientCompanyApiService.loading$;
    this.contacts$ = this.clientCompanyApiService.businessAccountsContacts$;
    this.shippingAddresses$ = this.clientShippingApiService.addresses$;
    this.creditMemo$ = this.clientCreditMemoApiService.creditMemos$;
    this.pricingByRfq$ = this.pricingApiService.pricingByRfq$;
    this.currentInvoice$ = this.clientPurchaseOrderApiService.currentPurchaseOrder$;
    this.pricingLevels$ = this.pricingLevelApiService.pricingLevels$;
    this.submittingForm$ = this.clientPurchaseOrderApiService.submittingForm$;
    this.loading$ = this.clientPurchaseOrderApiService.loading$;
    this.countries$ = this.locationApiService.countries$;
    this.uploadingSku$ = this.clientApiService.uploading$;
    this.invoiceTypes$ = this.invoiceApiService.invoiceTypes$;
    this.channelHubspotDeal$ = this.channelApiService.channelHubspotDeal$;
    this.salesPurgatorySettings$ =
      this.salesPurgatoryApiService.salesPurgatorySettings$;
    this.loadingWarehouseGroups$ = this.warehouseGroupService.loading$;
    this.loadingWarehouseGroupsOnSelect$ =
      this.rfqApiService.loadingWarehouseGroupsOnSelect$;
  }

  // TODO: Create type
  private initFormValues() :void {
    let defaultItemRows = 5;
    const lineItems = [];
    while (defaultItemRows--) {
      lineItems.push(this.rfqUtilService.emptyItemRow());
    }
    const currentInvoiceLineItems = this.currentInvoice?.line_items || [];

    const warehouseGroupId = this.currentInvoice?.warehouse_group_id;

    this.initialValues = {
      client: this.currentInvoice?.client || '',
      client_name: this.currentInvoice?.client?.business_name || '',
      created_by: this.currentInvoice?.created_by?.id || '',
      order_date: this.currentInvoice
        ? parseUTCStringToDateISO(this.currentInvoice?.order_date)
        : DateTime.now().toISODate(),
      ship_by_date: this.currentInvoice?.ship_by_date
        ? parseUTCStringToDateISO(this.currentInvoice.ship_by_date, {
            allowNull: true,
          })
        : null,
      customer_po_number: this.currentInvoice?.customer_po_number,
      ship_address: this.currentInvoice?.ship_address || null,
      ship_address_line_2: this.currentInvoice?.ship_address_line_2 || null,
      ship_city: this.currentInvoice?.ship_city || null,
      ship_state: this.currentInvoice?.ship_state || null,
      ship_zip: this.currentInvoice?.ship_zip || null,
      ship_country: this.currentInvoice?.ship_country || null,
      shipping_email: this.currentInvoice?.shipping_email || null,
      shipping_phone: this.currentInvoice?.shipping_phone || null,
      shipping_name: this.currentInvoice?.shipping_name || null,
      shipping_company: this.currentInvoice?.shipping_company || null,

      shipping_account_number: this.currentInvoice?.shipping_account_number || null,
      shipping_notes: this.currentInvoice?.shipping_notes || null,
      shipping_type: this.currentInvoice?.shipping_type || null,

      overridden: this.currentInvoice?.overridden || 0,
      will_affect_inventory: this.currentInvoice?.will_affect_inventory || 0,
      include_sales_reports: this.currentInvoice?.include_sales_reports || 0,
      tags: this.currentInvoice
        ? this.currentInvoice?.tags?.map((tag :any) => tag.id)
        : [],
      frequency: this.currentInvoice?.frequency || EOrderFrequency.ONETIME,
      is_limited_by_occurrence: this.currentInvoice?.is_limited_by_occurrence || 0,
      max_occurrences: this.currentInvoice?.max_occurrences || '',
      recurring_type: this.currentInvoice?.recurring_type || 'day',
      day_weekly: this.currentInvoice?.day_weekly || '',
      day_monthly: this.currentInvoice?.day_monthly || '',
      day_annually: this.currentInvoice?.day_annually || '',
      pricing_setting: this.currentInvoice?.pricing_setting || 'default',
      payment_term_title: this.currentInvoice?.payment_term_title || '100% Down',
      autopay: this.currentInvoice?.autopay || 0,
      autopay_after_days: this.currentInvoice?.autopay_after_days || 0,
      autoPushUpdatesToSalesOrder:
        this.currentInvoice?.client_purchase_order_type
          ?.auto_push_updates_to_sales_order,
      due_date: this.ftService.isActive('red_DV-2964_automated_billing')
        ? this.currentInvoice
          ? parseUTCStringToDateISO(this.currentInvoice.due_date, {
              allowNull: true,
            })
          : DateTime.now().plus({ days: this.defaultDueDays }).toISODate()
        : null,
      public_note: this.currentInvoice?.public_note || '',
      private_note: this.currentInvoice?.private_note || '',
      delivery_type:
        this.currentInvoice?.delivery_type || EOrderDeliveryType.STANDARD,
      warehouse_id: this.currentInvoice?.warehouse_id || 0,
      warehouse_group_id: warehouseGroupId,
      sales_channel_id: this.currentInvoice?.sales_channel_id,
      shipping_address_id: this.currentInvoice?.shipping_address_id || '',
      order_status: this.currentInvoice?.order_status || EOrderStatus.DRAFT,
      shipping_amount: this.currentInvoice?.shipping_amount || 0,
      tax_amount: this.currentInvoice?.tax_amount || 0,
      hubspot_deal_id: this.currentInvoice?.hubspot_deal_id || '',
      price_level_id: this.currentInvoice?.price_level_id || '',
      client_id: this.currentInvoice?.client_id || this.currentCompany?.id,
      client_contact_id: this.currentInvoice?.client_contact_id || '',
      client_purchase_order_type_id:
        this.currentInvoice?.client_purchase_order_type_id || null,
      client_purchase_order_type_label:
        this.currentInvoice?.client_purchase_order_type?.label || '',
      total_units: this.currentInvoice?.total_units || 0,
      total_amount: this.currentInvoice?.total_amount || 0,
      discount_amount: this.currentInvoice?.discount_amount || 0,
      discount_percent: this.currentInvoice?.discount_percent || 0,
      markup_amount: this.currentInvoice?.markup_amount || 0,
      markup_percent: this.currentInvoice?.markup_percent || 0,
      net_total_amount: this.currentInvoice?.net_total_amount || 0,
      alternate_ids: this.currentInvoice?.alternate_ids?.length
        ? this.fb.array(
            this.currentInvoice?.alternate_ids?.map((alternateId :any) =>
              this.fb.control(alternateId.value),
            ),
          )
        : this.fb.array([]),
      line_items: this.currentInvoice
        ? this.fb.array(
            currentInvoiceLineItems.map((lineItem :any) => {
              const {
                id,
                description,
                item,
                sku,
                product_name,
                is_kit,
                quantity,
                unit_price,
                net_total_amount,
                discount_amount,
                discount_percent,
                discount_amount_per_unit,
                markup_amount,
                markup_amount_per_unit,
                ordered_uom_id,
                type,
                order,
                row_type,
              } = lineItem;

              const unit_of_measures = item
                ? this.fb.array(
                    item?.unit_of_measures?.map((uom :any) =>
                      this.fb.group({
                        id: uom.id,
                        name: uom.name,
                      }),
                    ),
                  )
                : [];

              const ordered_uom = item
                ? item?.unit_of_measures?.find(
                    (uom :any) => uom.id === item?.default_selling_unit_id,
                  )
                : null;

              return this.fb.group({
                id: this.templateId ? 0 : id,
                description,
                item_id: item?.id,
                sku,
                product: lineItem,
                product_name,
                is_kit,
                quantity,
                original_unit_price: unit_price,
                unit_price,
                net_total_amount: this.getInitialLineItemNetTotalAmount({
                  net_total_amount,
                  quantity,
                  unit_price,
                }),
                discount_amount,
                discount_percent, // Not included in the payload
                discount_amount_per_unit,
                markup_amount,
                markup_amount_per_unit,
                unit_class_id: item?.unit_class_id,
                ordered_uom_id: ordered_uom_id || ordered_uom?.id || 0,
                order: order,
                unit_of_measures, // Not included in the payload
                stock: this.fb.control(item?.stock), // Not included in the payload
                location_stock: this.fb.control(item?.location_stock), // Not included in the payload
                oss_limit_notify: lineItem.oss_limit_notify, // Not included in the payload
                type, // Not included in the payload
                selected: false, // Not included in the payload// Not included in the payload Not included in the payload
                row_type,
                category: item?.category,
                subcategory: item?.subcategory,
              });
            }),
          )
        : this.fb.array(lineItems),
      creditMemoEntries: this.fb.array([]),
      customFieldValues: this.customFieldValues,
    };
  }

  private initForm() :void {
    const {
      alternate_ids,
      client_contact_id,
      client_purchase_order_type_id,
      client_purchase_order_type_label,
      client_id,
      client,
      client_name,
      created_by,
      day_annually,
      day_monthly,
      day_weekly,
      delivery_type,
      discount_amount,
      discount_percent,
      frequency,
      hubspot_deal_id,
      include_sales_reports,
      is_limited_by_occurrence,
      line_items,
      markup_amount,
      markup_percent,
      max_occurrences,
      net_total_amount,
      order_date,
      order_status,
      overridden,
      payment_term_title,
      autopay,
      autopay_after_days,
      autoPushUpdatesToSalesOrder,
      due_date,
      price_level_id,
      pricing_setting,
      private_note,
      public_note,
      recurring_type,
      ship_by_date,
      customer_po_number,
      ship_address_line_2,
      ship_address,
      ship_city,
      ship_country,
      ship_state,
      ship_zip,
      shipping_address_id,
      shipping_amount,
      shipping_company,
      shipping_email,
      shipping_name,
      shipping_phone,
      shipping_account_number,
      shipping_notes,
      shipping_type,
      tags,
      tax_amount,
      total_amount,
      total_units,
      warehouse_id,
      warehouse_group_id,
      sales_channel_id,
      will_affect_inventory,
      creditMemoEntries,
      customFieldValues,
    } = this.initialValues;

    this.form = this.fb.group({
      client_purchase_order_type_id: [
        client_purchase_order_type_id ?? 0,
        Validators.required,
      ],
      client_purchase_order_type_label: [client_purchase_order_type_label],
      created_by: [created_by],
      order_date: [order_date, Validators.required],
      line_items,
      ship_by_date: [ship_by_date],
      customer_po_number: [customer_po_number],
      ship_address: [ship_address],
      ship_address_line_2: [ship_address_line_2],
      ship_city: [ship_city],
      ship_state: [ship_state],
      ship_zip: [ship_zip],
      ship_country: [ship_country],
      shipping_email: [shipping_email],
      shipping_phone: [shipping_phone],
      shipping_name: [shipping_name],
      shipping_company: [shipping_company],
      shipping_account_number: [shipping_account_number],
      shipping_notes: [shipping_notes],
      shipping_type: [shipping_type],

      overridden: [overridden],
      will_affect_inventory: [will_affect_inventory],
      include_sales_reports: [include_sales_reports],
      tags: [tags],
      frequency: [frequency],
      is_limited_by_occurrence: [is_limited_by_occurrence],
      max_occurrences: [max_occurrences],
      recurring_type: [recurring_type],
      day_weekly: [day_weekly],
      day_monthly: [day_monthly],
      day_annually: [day_annually],
      pricing_setting: [pricing_setting],
      payment_term_title: [payment_term_title],
      autopay: [autopay],
      autopay_after_days: [autopay_after_days],
      due_date: [due_date],
      public_note: [public_note],
      private_note: [private_note],
      delivery_type: [delivery_type],
      warehouse_id: [warehouse_id],
      warehouse_group_id: [warehouse_group_id],
      sales_channel_id: [sales_channel_id],
      shipping_address_id: [shipping_address_id],
      order_status: [order_status],
      shipping_amount: [shipping_amount],
      tax_amount: [tax_amount],
      hubspot_deal_id: [hubspot_deal_id],
      price_level_id: [price_level_id],
      client_id: [client_id],
      client_contact_id: [client_contact_id],
      total_units: [total_units],
      total_amount: [total_amount],
      discount_amount: [discount_amount],
      discount_percent: [discount_percent],
      markup_amount: [markup_amount],
      markup_percent: [markup_percent],
      net_total_amount: [net_total_amount],
      alternate_ids,
      client, // Not included in payload,
      client_name: [client_name], // Not included in payload,
      creditMemoEntries,
      customFieldValues,
      defaultPosChannel: [null],
      autoPushUpdatesToSalesOrder,
    });

    // Initialize shouldIncludeAllWarehouseGroups based on initial defaultPosChannel value
    const initialChannel = this.form.get('defaultPosChannel')?.value;
    this.shouldIncludeAllWarehouseGroups = initialChannel?.channelType === 'sales_channel';
  }

  private getInvoiceSettings() :void {
    this.settingsSvc
      .getInvoiceSettings()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((resp :any) => {
        if (resp) {
          const { invoice_default_pos_sales_channel_id } = resp;
          if (!this.salesChannelIdControl.value) {
            this.salesChannelIdControl.setValue(
              invoice_default_pos_sales_channel_id,
            );

            this.getPosSalesChannelById(invoice_default_pos_sales_channel_id);
          }
        }
      });
  }

  private getPosSalesChannelById(id :number) :void {
    this.channelApiService
      .getById(id, { relations: 'warehouseGroup' })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (channel :IChannel) => {
          this.defaultPosChannelControl.setValue(channel);
          this.form.patchValue(
            {
              sales_channel_id: channel?.id,
              warehouse_group_id: channel?.warehouseGroupId,
            },
            { emitEvent: false },
          );
        },
      });
  }

  private getCompanies() :Observable<ICompany[]> {
    return this.companies$.pipe(
      tap((companies) => {
        if (companies) {
          if (this.paginateClientsPage > 1) {
            this.companies = [...this.companies, ...companies];
          } else {
            this.companies = companies;
          }
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getContacts() :Observable<IBusinessAccountContact[]> {
    return this.contacts$.pipe(
      tap((contacts) => {
        if (contacts) {
          const contactId = this.form.get('client_contact_id')?.value;
          const index = contacts.findIndex((contact) => contact.id === contactId);
          const finalIndex = index !== -1 ? index : 0;
          const contact = contacts[finalIndex];

          this.contacts = contacts;
          const defaultShippingAddress = this.shippingAddresses.find(
            (address) => address.default,
          );
          const defaultShippingAddressName =
            defaultShippingAddress?.firstName +
            ' ' +
            defaultShippingAddress?.lastName;
          if (this.initContactForm) {
            if (contacts?.length && contact) {
              if (this.currentCompany) {
                const email =
                  contact?.userAccount?.email ||
                  this.form.get('shipping_email')?.value;

                const phone =
                  contact?.userAccount?.phoneOne ||
                  this.form.get('shipping_phone')?.value;

                const name =
                  contact?.userAccount?.fullName ||
                  this.form.get('shipping_name')?.value;

                this.form.patchValue({
                  client_contact_id: contact?.id,
                  shipping_email: email,
                  shipping_phone: phone,
                  shipping_name:
                    defaultShippingAddress?.firstName &&
                    defaultShippingAddress?.lastName
                      ? defaultShippingAddressName
                      : name,
                });

                this.contacts[index] = {
                  ...contact,
                  userAccount: {
                    ...contact.userAccount,
                    email: email,
                    phoneOne: phone,
                    fullName: name,
                  },
                };
              } else {
                this.form.patchValue({
                  client_contact_id: '',
                  shipping_email: null,
                  shipping_phone: null,
                  shipping_name: null,
                  shipping_company: null,
                });
              }
            } else {
              if (this.form.get('client_id')?.value) {
                const primaryContact = contacts.find((contact) => contact.primary);
                this.form.patchValue({
                  client_contact_id: primaryContact?.id,
                  shipping_email: primaryContact?.userAccount?.email,
                  shipping_phone: primaryContact?.userAccount?.phoneOne,
                  shipping_name: primaryContact?.userAccount?.fullName?.trim(),
                });
              } else {
                this.form.patchValue({
                  client_contact_id: null,
                  shipping_email: null,
                  shipping_phone: null,
                  shipping_name: null,
                  shipping_company: null,
                });
              }
            }
          } else {
            this.initContactForm = true;
          }
        }

        this.cd.detectChanges();
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getShippingAddresses() :Observable<IClientShipping[]> {
    return this.shippingAddresses$.pipe(
      tap((shippingAddresses) => {
        if (shippingAddresses) {
          this.shippingAddresses = shippingAddresses;
          if (
            shippingAddresses?.length &&
            !this.currentInvoice &&
            this.currentCompany
          ) {
            const defaultShippingAddress = shippingAddresses.find(
              (address) => address.default,
            );
            if (defaultShippingAddress) {
              this.form.patchValue({
                shipping_address_id: defaultShippingAddress.id,
              });
              this.processShippingName(defaultShippingAddress);
            }
          }
          this.setClientFormShipping(this.form.value);
        }
        this.cd.detectChanges();
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private processShippingName(defaultShippingAddress :IClientShipping) :void {
    const contactId = this.form.get('client_contact_id')?.value;
    const index = this.contacts.findIndex((contact) => contact.id === contactId);
    const finalIndex = index !== -1 ? index : 0;
    if (defaultShippingAddress?.firstName && defaultShippingAddress?.lastName) {
      this.form.patchValue({
        shipping_name:
          defaultShippingAddress.firstName + ' ' + defaultShippingAddress.lastName,
      });
    } else if (this.contacts[finalIndex]) {
      this.form.patchValue({
        shipping_name: this.contacts[finalIndex]?.userAccount?.fullName,
      });
    }
    this.cd.detectChanges();
  }

  private loadWarehouseGroups() :void {
    this.warehouseGroupService.get({});
    this.warehouseGroupService.warehouseGroups$
      .pipe(
        takeUntil(this.onDestroy$),
        catchError((error :any[]) :Observable<any> => {
          // Declare return type of catchError as Observable<any>
          this.snackBar.open(Object.values(error)[0], 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });

          return EMPTY; // Return an EMPTY observable that emits no items to the Observer and immediately emits a complete notification
        }),
      )
      .subscribe((warehouseGroup :IWarehouseGroup[]) => {
        this.warehouseGroups = warehouseGroup;

        this.updateWarehouseGroups();
      });
  }

  private getCreditMemos() :Observable<IClientCreditMemo[]> {
    return this.creditMemo$.pipe(
      tap((creditMemos) => {
        this.creditMemos = creditMemos?.filter(
          (creaditMemo) => creaditMemo.balanceAmount > 0,
        );
        this.setAvailableCreditMemos();
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getInvoiceTypes() :Observable<IResponse> {
    return this.invoiceTypes$.pipe(
      tap((response :IResponse) => {
        const invoiceTypes = response?.data || [];

        if (
          invoiceTypes.length > 0 &&
          !this.form.get('client_purchase_order_type_id')?.value
        ) {
          const invoiceType = invoiceTypes[0];

          const orderDateValue =
            this.form.get('order_date')?.value ?? DateTime.now().toISODate();
          const orderDate = DateTime.fromISO(orderDateValue);
          const dueDateDays =
            invoiceType?.dueDateDays ||
            this.currentCompany?.due_date_days ||
            this.defaultDueDays;
          const dueDate = orderDate.plus({ days: dueDateDays }).toISODate();

          this.form.patchValue({
            client_purchase_order_type_id: invoiceType?.id,
            client_purchase_order_type_label: invoiceType?.label,
            warehouse_group_id: invoiceType?.warehouseGroupId,
            autopay: invoiceType?.autopay,
            autopay_after_days: invoiceType?.autopayAfterDays,
            due_date: dueDate,
            autoPushUpdatesToSalesOrder: invoiceType?.autoPushUpdatesToSalesOrder,
          });
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getCurrentInvoice() :Observable<any> {
    return this.currentInvoice$.pipe(
      tap((invoice) => {
        this.currentInvoice = invoice;

        this.creditMemoPaymentLogs = invoice?.credit_memo_payment_log?.filter(
          (creditMemoPaymentLog :ICreditMemoPaymentLog) =>
            creditMemoPaymentLog.reference_id,
        );

        if (invoice) {
          this.initContactForm = false;
          // SET DISCOUNT ENTRIESGIT
          this.discountEntries = invoice?.discounts?.map((discount :any) => ({
            discountTypeId: discount?.discount_type_id,
            discountCode: discount?.discount_code,
            discountType: discount?.discount_type,
            discountAmount: discount?.discount_amount,
            discountPercent: 100,
            discountable: {
              label: discount?.discountable?.label,
            },
          }));

          this.onSelectCompany({
            currentCompany: invoice.client,
          });

          this.initFormValues();
          this.initForm();
          this.setRequiredValidators();
          this.listenToLineItemsChange();
          this.listenToShippingAmountChange();
          this.listenToTaxAmountChange();
          this.listenToShippingAddress();
          this.listenToPricingLevelChange();
          this.setCreditMemoPaymentLogs();
          this.updateSelectedWarehouseGroup();
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getSalesPurgatorySettings() :Observable<ISalesPurgatorySettings> {
    return this.salesPurgatorySettings$.pipe(
      tap((settings :ISalesPurgatorySettings) => {
        const { value } = settings;
        if (value) {
          this.salesPurgatorySettings = JSON.parse(value);
          this.setRequiredValidators();
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private setRequiredValidators() :void {
    if (this.salesPurgatorySettings?.push_client_invoice_to_shipstation) {
      const allFields = [
        ...InvoiceConfig.shipStationRequiredFields.contact,
        ...InvoiceConfig.shipStationRequiredFields.shipping,
      ];
      allFields.forEach((field :string) => {
        const control = this.form.get(field);
        control?.setValidators(Validators.required);
        control?.updateValueAndValidity();
      });
    }
  }

  private getPricingByRfq() :Observable<{
    [key :string] :IPrice;
  }> {
    return this.pricingByRfq$.pipe(
      tap((pricingByRfq) => {
        this.pricingByRfq = pricingByRfq;
        Object.keys(pricingByRfq).forEach((itemId :string) => {
          this.updateLineItemPrice(pricingByRfq[itemId]);
        });
        this.setDiscountEntries();
        this.cd.detectChanges();
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private updateLineItemPrice(rfqPricing :IPrice) :void {
    const items :any[] = this.lineItemsFormArray.value;
    const filteredIndexes = items
      .map((item, index) =>
        item.item_id === rfqPricing.requestedRfqId &&
        item.ordered_uom_id === rfqPricing.requestedUomId
          ? index
          : -1,
      )
      .filter((index) => index !== -1);

    if (filteredIndexes.length === 0) {
      return;
    }

    filteredIndexes.forEach((index) => {
      const item = items[index];
      const itemForm = this.lineItemsFormArray.at(index) as UntypedFormGroup;
      const unitPriceControl = itemForm.get('unit_price');
      const origUnitPriceControl = itemForm.get('original_unit_price');
      const netTotalAmountControl = itemForm.get('net_total_amount');
      const wholesalePrice = rfqPricing.wholesalePrice ? Number(rfqPricing.wholesalePrice?.toFixed(2)) : item.unit_price;

      origUnitPriceControl?.patchValue(
        wholesalePrice,
      );

      netTotalAmountControl?.patchValue(
        wholesalePrice * item.quantity,
      );

      if (!item?.is_overridden) {
        unitPriceControl?.patchValue(wholesalePrice);
      }
    });
  }

  private getCurrentCompany() :Observable<ICompany | null> {
    return this.currentCompany$.pipe(
      tap((company) => {
        this.currentCompany = company;
        if (company) {
          this.updateSelectedWarehouseGroup();

          this.form.patchValue({
            client_id: company.id,
            client: company,
            payment_term_title: company?.payment_term,
          });

          if (this.loadContact) {
            this.clientCompanyApiService.getCompanyContacts({
              businessAccountId: company?.id.toString(),
              limit: '1000',
            });
          }

          this.clientCreditMemoApiService.get({
            businessAccountId: company?.id,
            params: {
              sortField: 'created_at',
              sortDirection: 'asc',
              status: EClientCreditMemoStatus.ACTIVE,
              limit: '100',
            },
          });

          this.clientShippingApiService.get({
            businessAccountId: company?.id,
            params: { allAddresses: 'true' },
          });

          this.loadContact = true;
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getChannelHubspotDeal() :Observable<IChannelHubspotDeal> {
    return this.channelHubspotDeal$.pipe(
      tap((channelHubspotDeal) => {
        if (channelHubspotDeal?.companies?.length) {
          const company = channelHubspotDeal?.companies[0];
          this.clientApiService
            .get({
              hubspot_company_id: company.companyId?.toString(),
            })
            .pipe(
              tap((response) => {
                if (response?.data?.length) {
                  this.clientCompanyApiService.setCurrentCompany(response.data[0]);

                  this.form.patchValue({
                    hubspot_deal_id: channelHubspotDeal.dealId,
                  });
                }
              }),
              takeUntil(this.onDestroy$),
            )
            .subscribe();
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private onSetDefaultCompanyDueDate(currentCompany :ICompany) :void {
    const orderDateValue =
      this.form.get('order_date')?.value ?? DateTime.now().toISODate();
    const orderDate = DateTime.fromISO(orderDateValue);
    let dueDateDays = this.defaultDueDays;

    if (currentCompany?.due_date_days) {
      dueDateDays = currentCompany?.due_date_days;
    }

    this.form.patchValue({
      due_date: orderDate.plus({ days: dueDateDays }).toISODate(),
    });
  }

  private listToClientFormChange() :void {
    this.form.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.onDestroy$))
      .subscribe((formValue) => {
        const shippingEmail = this.form.get('shipping_email');
        const shippingPhone = this.form.get('shipping_phone');
        const shippingName = this.form.get('shipping_name');
        const shippingCompany = this.form.get('shipping_company');
        const shippingAddress = this.form.get('ship_address');
        const shippingAddressLine2 = this.form.get('ship_address_line_2');
        const shippingCity = this.form.get('ship_city');
        const shippingState = this.form.get('ship_state');
        const shippingCountry = this.form.get('ship_country');
        const shippingZip = this.form.get('ship_zip');
        const shippingAccountNumber = this.form.get('shipping_account_number');
        const shippingNotes = this.form.get('shipping_notes');
        const shippingType = this.form.get('shipping_type');
        // CHECK IF SHIPPING CONTACT IS CHANGED
        if (
          shippingEmail?.dirty ||
          shippingPhone?.dirty ||
          shippingName?.dirty ||
          shippingCompany?.dirty
        ) {
          this.setClientFormContact(formValue);
        }

        // CHECK IF SHIPPING ADDRESS IS CHANGED
        if (
          shippingAddress?.dirty ||
          shippingAddressLine2?.dirty ||
          shippingCity?.dirty ||
          shippingState?.dirty ||
          shippingCountry?.dirty ||
          shippingZip?.dirty ||
          shippingAccountNumber?.dirty ||
          shippingNotes?.dirty ||
          shippingType?.dirty
        ) {
          this.setClientFormShipping(formValue);
        }
      });
  }

  private listenToLineItemsChange() :void {
    this.lineItemsFormArray.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.onDestroy$))
      .subscribe((items) => {
        this.updatingFormFields.next(true);
        this.setLineItem(items);
        this.setDiscountEntries();
        this.lineItemsFormArray.markAsDirty();
        this.updatingFormFields.next(false);
      });
  }

  private listenToShippingAmountChange() :void {
    this.shippingAmountControl?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((amount :number) => {
        this.netTotalAmountControl?.patchValue(this.subTotal + amount);
        this.setDiscountEntries();
      });
  }

  private listenToTaxAmountChange() :void {
    this.taxAmountControl?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((amount :number) => {
        this.netTotalAmountControl?.patchValue(this.subTotal + amount);
        this.setDiscountEntries();
      });
  }

  private listenToShippingAddress() :void {
    this.shippingAddressIdControl?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((id :number) => {
        const shippingAddress = this.shippingAddresses.find(
          (address) => address.id === id,
        );
        if (shippingAddress) {
          this.form.patchValue({
            ship_address: shippingAddress.address,
            ship_address_line_2: shippingAddress.addressLine2,
            ship_city: shippingAddress.city,
            ship_state: shippingAddress.state,
            ship_zip: shippingAddress.postalCode,
            ship_country: shippingAddress.country,
            shipping_company:
              shippingAddress.companyName || this.currentCompany?.business_name,
            shipping_account_number: shippingAddress.accountNumber,
            shipping_notes: shippingAddress.notes,
            shipping_type: shippingAddress.shippingType,
          });
        }
      });
  }

  private listenToPricingLevelChange() :void {
    this.pricingLevelIdControl?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        if (this.lineItemsFormArray?.value?.length) {
          // Recalculate line items
          this.lineItemsFormArray.value.forEach((item :any) => {
            this.getRfqById(item);
          });
        }
      });
  }

  private listenToDefaultPosChannelChange() :void {
    this.defaultPosChannelControl?.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((selectedChannel) => {
        this.shouldIncludeAllWarehouseGroups = selectedChannel?.channelType === 'sales_channel';
      });
  }

  // TODO: CREATE TYPE
  private setDiscountEntries() :void {
    const totalAmountControl = this.form.get('total_amount');

    if (totalAmountControl && this.netTotalAmountControl) {
      totalAmountControl.patchValue(this.subTotal, {
        emitEvent: false,
      });
      totalAmountControl.markAsDirty();
    }
    if (this.netTotalAmountControl) {
      const netTotal = this.subTotal + (this.shippingAmountControl.value || 0);
      let taxAmountValue :number = 0;

      if (
        this.currentCompany &&
        !this.currentCompany?.tax_exempt &&
        this.currentCompany?.tax_rate > 0
      ) {
        taxAmountValue = this.subTotal * (this.currentCompany.tax_rate / 100);
        this.form
          .get('tax_amount')
          ?.patchValue(taxAmountValue.toFixed(4), { emitEvent: false });
      }

      this.netTotalAmountControl.patchValue(
        netTotal + taxAmountValue - this.discountAmountLineItems,
        {
          emitEvent: false,
        },
      );
      this.netTotalAmountControl.markAsDirty();

      this.cd.detectChanges();
    }
  }

  // TODO: CREATE TYPE
  private setLineItem(items :any[]) :void {
    items.forEach((item :any, index :number) => {
      if (!item.sku || !item.sku.length) {
        return;
      }
      const itemForm = this.lineItemsFormArray.at(index) as UntypedFormGroup;
      const discountAmountControl = itemForm.get('discount_amount');
      const discountAmountUnitControl = itemForm.get('discount_amount_per_unit');
      const discountPercentControl = itemForm.get('discount_percent');
      const quantityControl = itemForm.get('quantity');
      const itemNetTotalControl = itemForm.get('net_total_amount');
      const unitPriceControl = itemForm.get('unit_price');
      const unitMeassureControl = itemForm.get('ordered_uom_id');

      // QUANTITY CHANGE
      if (quantityControl?.dirty) {
        if (!this.form.get('overridden')?.value) {
          this.getRfqById(item);
        }
      }

      // UNIT PRICE CHANGE
      if (unitPriceControl?.dirty) {
        this.setDiscountPercentLineItem({
          discountPercentControl,
          discountAmountUnitControl,
          discountAmountControl,
          item,
        });
      }

      // DISCOUNT PERCENT CHANGE
      if (discountPercentControl?.dirty || quantityControl?.dirty) {
        this.setDiscountAmountLineItem({
          discountPercentControl,
          discountAmountUnitControl,
          discountAmountControl,
          item,
        });

        quantityControl?.markAsPristine();
      }

      // DISCOUNT AMOUNT CHANGE
      if (discountAmountControl?.dirty || quantityControl?.dirty) {
        this.setDiscountPercentLineItem({
          discountPercentControl,
          discountAmountUnitControl,
          discountAmountControl,
          item,
        });
      }

      // UOM CHANGE
      if (unitMeassureControl?.dirty) {
        this.getRfqById(item);
      }

      itemNetTotalControl?.patchValue(
        Number(
          (
            quantityControl?.value * unitPriceControl?.value -
            discountAmountControl?.value
          ).toFixed(2),
        ),
        { emitEvent: false },
      );
      discountAmountControl?.markAsPristine();
      discountAmountUnitControl?.markAsPristine();
      discountPercentControl?.markAsPristine();
      quantityControl?.markAsPristine();
      itemNetTotalControl?.markAsPristine();
      unitPriceControl?.markAsPristine();
      unitMeassureControl?.markAsPristine();
    });
  }

  private setDiscountPercentLineItem(data :{
    discountPercentControl :AbstractControl | null;
    discountAmountUnitControl :AbstractControl | null;
    discountAmountControl :AbstractControl | null;
    item :any;
  }) :void {
    const { discountPercentControl, discountAmountUnitControl, item } = data;
    if (item.discount_amount === null || !item.quantity || !item.unit_price) {
      discountPercentControl?.patchValue(0);

      return;
    }
    const discountPercentAmount = Number(
      ((item.discount_amount / (item.quantity * item.unit_price)) * 100).toFixed(2),
    );
    const discountAmount = Number(item.discount_amount.toFixed(2));
    discountPercentControl?.patchValue(
      isNaN(discountPercentAmount) ? 0 : discountPercentAmount,
      { emitEvent: false },
    );
    discountAmountUnitControl?.patchValue(
      isNaN(discountAmount) ? 0 : discountAmount,
      {
        emitEvent: false,
      },
    );
  }

  private setDiscountAmountLineItem(data :{
    discountPercentControl :AbstractControl | null;
    discountAmountUnitControl :AbstractControl | null;
    discountAmountControl :AbstractControl | null;
    item :any;
  }) :void {
    const { discountAmountUnitControl, discountAmountControl, item } = data;
    if (item.discount_percent === null || !item.quantity || !item.unit_price) {
      discountAmountControl?.patchValue(0);

      return;
    }

    const amount = Number(
      ((item.discount_percent / 100) * (item.quantity * item.unit_price)).toFixed(
        2,
      ),
    );
    discountAmountControl?.patchValue(isNaN(amount) ? 0 : amount, {
      emitEvent: false,
    });
    discountAmountUnitControl?.patchValue(isNaN(amount) ? 0 : amount, {
      emitEvent: false,
    });
  }

  // TODO: CREATE TYPE
  private setClientFormContact(form :any) :void {
    let currentContact = this.contacts.find(
      (contact) => contact.userAccount.id === form.client_contact_id,
    );
    if (currentContact) {
      currentContact = {
        ...currentContact,
        userAccount: {
          ...currentContact.userAccount,
          email: form.shipping_email,
          phoneOne: form.shipping_phone,
          fullName: form.shipping_name,
        },
      };

      this.contacts = this.contacts.map((contact) =>
        contact.userAccount.id === currentContact?.userAccount.id
          ? currentContact
          : contact,
      );
    }
  }

  // TODO: CREATE TYPE
  private setClientFormShipping(form :any) :void {
    let currentShipping = this.shippingAddresses.find(
      (shipping) => shipping.id === form.shipping_address_id,
    );
    if (currentShipping) {
      currentShipping = {
        ...currentShipping,
        address: form.ship_address,
        addressLine2: form.ship_address_line_2,
        city: form.ship_city,
        state: form.ship_state,
        country: form.ship_country,
        postalCode: form.ship_zip,
        accountNumber: form.shipping_account_number,
        notes: form.shipping_notes,
        shippingType: form.shipping_type,
      };

      this.shippingAddresses = this.shippingAddresses.map((shipping) =>
        shipping.id === currentShipping?.id ? currentShipping : shipping,
      );

      // Update shipping_address_id
      this.form.patchValue({
        shipping_address_id: currentShipping.id,
      });
    }
  }

  private resetForm() :void {
    this.clientCompanyApiService.setCurrentCompany(null);
    this.clientCompanyApiService.setContacts([]);
    this.clientShippingApiService.setShippingAddresses([]);
    this.clientPurchaseOrderApiService.setCurrentPurchaseOrder(null);
    this.form.reset();
    this.initFormValues();
    this.initForm();
    this.setRequiredValidators();
  }

  private getRfqById(item :any) :void {
    if (item) {
      this.pricingApiService.getByRfq({
        rfqId: item.item_id?.toString(),
        quantity: item.quantity,
        uomId: item?.ordered_uom_id?.toString(),
        businessAccountId: this.currentCompany?.id?.toString() || '',
        priceLevelId: this.pricingLevelIdControl?.value || null,
      });
    }
  }

  private setAvailableCreditMemos() :void {
    if (!this.form.value.client_id) {
      this.creditMemos = [];
      this.invoiceCreditMemoFormArray.controls = [];
    }
    if (this.creditMemos?.length > 0 && !this.isEditInvoice) {
      this.creditMemos.forEach((creditMemo, index :number) => {
        this.invoiceCreditMemoFormArray.setControl(
          index,
          this.fb.group({
            creditMemo: creditMemo,
            amount: creditMemo.balanceAmount,
            applyCreditMemoEntry: true,
          }),
        );
      });
    }
    this.cd.detectChanges();
  }

  private setCreditMemoPaymentLogs() :void {
    if (this.isEditInvoice && this.creditMemoPaymentLogs?.length > 0) {
      this.creditMemoPaymentLogs.forEach((creditMemoPaymentLog, index :number) => {
        this.invoiceCreditMemoFormArray.setControl(
          index,
          this.fb.group({
            creditMemo: creditMemoPaymentLog.credit_memo,
            amount: creditMemoPaymentLog.payment_amount,
            applyCreditMemoEntry: false,
            disable: true,
          }),
        );
      });
    }
  }

  private updateRfq(payload :any) :void {
    this.clientPurchaseOrderApiService
      .update({ id: this.currentInvoice.id, payload })
      .pipe(
        tap(() => {
          this.snackBar.open('Invoice successfully updated.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.resetForm();
          this.router.navigate([this.redirectUrl]);
        }),
        takeUntil(this.onDestroy$),
        catchError((error :any[]) :any => {
          this.snackBar.open(Object.values(error)[0], 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        }),
      )
      .subscribe();
  }

  private updateLineItemPrices() :void {
    const lineItems :any[] = this.lineItemsFormArray.value.filter(
      (lineItemValue :any) => lineItemValue.sku.length > 0 && lineItemValue.product,
    );
    if (!lineItems.length) {
      return;
    }
    this.updatingFormFields.next(true);
    const baseDelay = 10; // milliseconds

    const observables = lineItems.map((item :any, index :number) => {
      return this.pricingApiService
        .getRfqPriceAsync({
          rfqId: item.item_id?.toString(),
          quantity: item.quantity,
          uomId: item?.ordered_uom_id?.toString(),
          businessAccountId: this.currentCompany?.id?.toString() || '',
          priceLevelId: this.pricingLevelIdControl?.value || null,
        })
        .pipe(delay(baseDelay * (index + 1)));
    });

    forkJoin(observables)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((results) => {
        results.forEach((result :IPrice, index :number) => {
          if (result.rfq) {
            this.updateLineItemPrice(result);
          }
        });
        this.setDiscountEntries();
        this.cd.detectChanges();
        this.updatingFormFields.next(false);
      });
  }

  private getInitialLineItemNetTotalAmount(data :{
    net_total_amount :number;
    quantity :number;
    unit_price :number;
  }) :number {
    const { net_total_amount, quantity, unit_price } = data;

    return net_total_amount || quantity * unit_price;
  }

  private updateSelectedWarehouseGroup() :void {
    let warehouseGroup = null;

    if (
      this.currentInvoice?.created_from === ClientPurchaseOrderCreatedFrom.B2BPORTAL
    ) {
      warehouseGroup = this.currentInvoice?.warehouse_group;
    }

    if (
      warehouseGroup &&
      Number(this.currentInvoice?.client_id) !== this.currentCompany?.id
    ) {
      this.currentWarehouseGroup = warehouseGroup;

      // Patch the form value only if not created from B2B portal
      if (
        this.currentInvoice?.created_from !==
        ClientPurchaseOrderCreatedFrom.B2BPORTAL
      ) {
        this.form.patchValue({ warehouse_group_id: warehouseGroup.id });
      }
      this.updateWarehouseGroups();
    }
  }

  private updateWarehouseGroups() :void {
    // Check and add warehouse group if it does not exist
    if (!this.currentWarehouseGroup) {
      return;
    }

    const warehouseGroupExists = this.warehouseGroups.find(
      (wg) => wg.id === this.currentWarehouseGroup.id,
    );
    if (!warehouseGroupExists) {
      this.warehouseGroups.push(this.currentWarehouseGroup);
    }
  }

  private loadDefaultWarehouseGroup() :void {
    this.warehouseGroupService.getDefaultWarehouseGroup().subscribe({
      next: (response :any) => {
        this.defaultWarehouseGroupFromInventorySettings = response;
      },
      error: (error) => {
        this.snackBar.open('Default warehouse group not set.', 'Fail', {
          duration: SnackBarConfig.DEFAULT.duration,
        });
      },
    });
  }

  // TODO: Refactor implement global validation

  get selectedShippingAddress() :string {
    if (this.shippingAddresses?.length) {
      const shippingAddressId = this.form.get('shipping_address_id')?.value;
      const matchedAddress = this.shippingAddresses.find(
        (address) => address.id === shippingAddressId,
      );

      if (matchedAddress) {
        return `[${matchedAddress.companyName}]${matchedAddress.address}`;
      }
    }

    return '';
  }

  get lineItemsFormArray() :UntypedFormArray {
    return this.form.get('line_items') as UntypedFormArray;
  }

  get invoiceCreditMemoFormArray() :UntypedFormArray {
    return this.form.get('creditMemoEntries') as UntypedFormArray;
  }

  get totalCreditMemoEntryAmount() :number {
    return this.invoiceCreditMemoFormArray.controls
      .filter((creditMemoEntry) => creditMemoEntry.value.applyCreditMemoEntry)
      .map((creditMemoEntry) => creditMemoEntry.value.amount)
      .reduce((acc :number, curr :number) => acc + curr, 0);
  }

  get isInValidCreditMemoEntryId() :boolean {
    return (
      this.invoiceCreditMemoFormArray.controls.filter(
        (creditMemoEntry) => !creditMemoEntry.value.creditMemo?.id,
      )?.length > 0
    );
  }

  get hasInvalidCreditMemoEntryAmount() :boolean {
    return (
      this.invoiceCreditMemoFormArray.controls.filter(
        (creditMemoEntry) =>
          creditMemoEntry.value?.creditMemo?.balanceAmount <
          creditMemoEntry.value?.amount,
      ).length > 0
    );
  }

  get hasNegativeCreditMemoEntryAmount() :boolean {
    return (
      this.invoiceCreditMemoFormArray.controls.filter(
        (creditMemoEntry) => creditMemoEntry.value?.amount <= 0,
      ).length > 0
    );
  }

  get netTotalAmountControl() :UntypedFormControl {
    return this.form.get('net_total_amount') as UntypedFormControl;
  }

  get shippingAmountControl() :UntypedFormControl {
    return this.form.get('shipping_amount') as UntypedFormControl;
  }

  get taxAmountControl() :UntypedFormControl {
    return this.form.get('tax_amount') as UntypedFormControl;
  }

  get shippingAddressIdControl() :UntypedFormControl {
    return this.form.get('shipping_address_id') as UntypedFormControl;
  }

  get pricingLevelIdControl() :UntypedFormControl {
    return this.form.get('price_level_id') as UntypedFormControl;
  }

  get subTotal() :number {
    return this.lineItemsFormArray.value
      .map((item :any) => {
        const quantity = Number(item.quantity) || 0;
        const unit_price = Number(item.unit_price) || 0;

        return quantity * unit_price;
      })
      .reduce(
        (accumulator :number, currentValue :number) => accumulator + currentValue,
        0,
      );
  }

  get discountAmountLineItems() :number {
    return this.lineItemsFormArray?.value
      ?.map((item :any) => item.discount_amount)
      .reduce(
        (accumulator :number, currentValue :number) =>
          Number(accumulator || 0) + Number(currentValue || 0),
        0,
      );
  }

  get discountAmount() :number {
    const discountEntryAmount = this.discountEntries
      .map((entry) => entry.discountAmount)
      .reduce(
        (accumulator, currentValue) =>
          Number(accumulator || 0) + Number(currentValue || 0),
        0,
      );

    return this.discountAmountLineItems + discountEntryAmount;
  }

  get discountPercent() :number {
    return Number(
      (
        (this.discountAmount / (this.form.get('total_amount')?.value || 0)) *
        100
      ).toFixed(2),
    );
  }

  get canRejectOrApprovePurchaseOrder() :boolean {
    return (
      this.currentInvoice &&
      this.currentInvoice.id &&
      this.currentInvoice.approval_status ===
        EInvoiceApprovalStatus.APPROVAL_REQUIRED
    );
  }

  get isEditInvoice() :boolean {
    return this.currentInvoice?.id && this.templateId === '';
  }

  get isValidPaymentNetAmount() :boolean {
    return this.netTotalAmountControl.value >= this.totalCreditMemoEntryAmount;
  }

  get hasInvalidPurgatorySettingsInput() :boolean {
    return (
      this.form.get('shipping_email')?.invalid ||
      this.form.get('shipping_phone')?.invalid ||
      this.form.get('shipping_name')?.invalid ||
      this.form.get('shipping_company')?.invalid ||
      this.form.get('ship_address')?.invalid ||
      this.form.get('ship_city')?.invalid ||
      this.form.get('ship_state')?.invalid ||
      this.form.get('ship_country')?.invalid ||
      this.form.get('ship_zip')?.invalid ||
      false
    );
  }

  get pushClientInvoiceToShipstation() :boolean {
    return this.salesPurgatorySettings?.push_client_invoice_to_shipstation || false;
  }

  get canSaveInvoiceDraft() :boolean {
    return (this.currentInvoice?.order_status === EInvoiceStatus.ACTIVE ||
      this.currentInvoice?.order_status === EInvoiceStatus.COMPLETED) &&
      this.currentInvoice?.sales_order &&
      !this.templateId
      ? false
      : true;
  }

  get customFieldValues() :string {
    const values = this.currentInvoice?.custom_field_values.map(
      (customFieldValue :ICustomFieldValue) => ({
        custom_field: customFieldValue.custom_field_id,
        value:
          customFieldValue.value_date ||
          customFieldValue.value_number ||
          customFieldValue.value_string,
      }),
    );

    return JSON.stringify(values);
  }

  get salesChannelIdControl() :UntypedFormControl {
    return this.form.get('sales_channel_id') as UntypedFormControl;
  }

  get totalUnits() :number {
    return this.lineItemsFormArray?.value
      .filter((item :any) => item.row_type !== ELineItemRowType.SUB_TOTAL)
      .reduce((acc :number, curr :any) => acc + parseFloat(curr.quantity || 0), 0);
  }

  get isLoading$() :Observable<boolean> {
    return combineLatest([
      this.submittingForm$,
      this.loading$,
      this.loadingWarehouseGroups$,
      this.loadingWarehouseGroupsOnSelect$,
    ]).pipe(
      map(
        ([
          submittingForm,
          loading,
          loadingWarehouseGroups,
          loadingWarehouseGroupsOnSelect,
        ]) =>
          submittingForm ||
          loading ||
          loadingWarehouseGroups ||
          loadingWarehouseGroupsOnSelect,
      ),
    );
  }

  get warehouseGroupId() :number {
    return this.form.get('warehouse_group_id')?.value;
  }

  get actionDisabled() :boolean {
    return (
      this.form.invalid ||
      !this.lineItemsFormArray?.value?.filter((item :any) => item.sku)?.length ||
      this.updatingFormFields.getValue()
    );
  }

  setPermissions() :void {
    const activePermissions :string[] = [
      EInvoicePermission.INVOICE_CREATE,
      EInvoicePermission.INVOICE_UPDATE,
      EInvoicePermission.INVOICE_CREATE_ACTIVE,
    ];
    const completedPermissions :string[] = [
      EInvoicePermission.INVOICE_CREATE,
      EInvoicePermission.INVOICE_UPDATE,
    ];
    const draftPermissions :string[] = [
      EInvoicePermission.INVOICE_CREATE,
      EInvoicePermission.INVOICE_UPDATE,
      EInvoicePermission.INVOICE_CREATE_DRAFT,
    ];
    if (
      this.currentInvoice?.id &&
      this.currentInvoice?.sales_order?.orderStatus == ESalesOrderStatus.SHIPPED
    ) {
      activePermissions.push(EInvoicePermission.INVOICE_SHIPPED_UPDATE_PRICING);
      completedPermissions.push(EInvoicePermission.INVOICE_SHIPPED_UPDATE_PRICING);
      draftPermissions.push(EInvoicePermission.INVOICE_SHIPPED_UPDATE_PRICING);
    }

    // Active Permission
    this.permissionService
      .hasPermission(activePermissions)
      .then((hasPermission :boolean) => {
        this.canSaveActiveSubject.next(hasPermission);
      });

    // Completed permission
    this.permissionService
      .hasPermission(completedPermissions)
      .then((hasPermission :boolean) => {
        this.canSaveCompletedSubject.next(hasPermission);
      });

    // Draft permission
    this.permissionService
      .hasPermission(draftPermissions)
      .then((hasPermission :boolean) => {
        this.canSaveDraftSubject.next(hasPermission);
      });
  }

  get canGenerateB2BLink() :boolean {
    return (
      this.currentInvoice?.order_status === this.invoiceStatus.DRAFT &&
      this.lineItemsFormArray?.value?.length > 0 &&
      !this.currentInvoice?.shareable_token
    );
  }

  get defaultPosChannelControl() :UntypedFormControl {
    return this.form.get('defaultPosChannel') as UntypedFormControl;
  }  
}

